import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthBaseService {
    constructor(
        public http: HttpClient,
        public authService: AuthService
    ) {}

    PAGE_SIZE = 25;

    apiUrl(endpoint: string): string {
        const host: string = (window as any)['__env'].apiEndpoint;
        const url = `${host}/${endpoint}`;
        return url;
    }

    getOptions() {
        return {
            withCredentials: true
        };
    }

    checkAndRenewToken() {
        this.authService.checkAndRenewToken();
    }
}
